import { Button, Col, Input, message, Modal, Row, Table } from 'antd';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Mutation } from 'react-apollo';
import { client } from 'src/services/api';

import { User } from './Users';

interface Props {
  userId: number;
}

export interface NewUser extends User {
  key: number;
}

export const mergeAccountMutation = gql`
  mutation mergeAccount($originUserId: ID!, $userId: ID!) {
    mergeAccount(originUserId: $originUserId, userId: $userId) {
      id
    }
  }
`;

export const userQuery = gql`
  query userQueryByMobile($mobile: String, $name: String) {
    users(mobile: $mobile, name: $name) {
      id
      name
      mobile
      avatarUrl
      region
    }
  }
`;

interface State {
  userId?: number;
  isTransferOwnerOfCoursePopupConfirmVisible: boolean;
  mobile: string;
  user?: User;
  name: string;
  userList?: User[];
}

interface UserListData {
  users: User[];
}

export class TransferOwnerOfCourse extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isTransferOwnerOfCoursePopupConfirmVisible: false,
      mobile: '',
      name: '',
    };
  }

  onClickTransferButton = () => {
    this.setState({ isTransferOwnerOfCoursePopupConfirmVisible: true });
  };

  cancelTransferOwnerOperation = () => {
    this.setState({ isTransferOwnerOfCoursePopupConfirmVisible: false, mobile: '' });
  };

  onClickSearchUser = async () => {
    const { mobile, name } = this.state;
    if (!mobile.trim() && !name.trim()) {
      message.warning('请至少填写一项～');
      return;
    }
    const response = await client.query<UserListData>({
      query: userQuery,
      variables: { mobile, name },
    });
    const userList = (response.data && response.data.users) || [null];
    if (!userList) {
      message.error('找不到相关用户！');
    }
    this.setState({ userList });
  };

  onMobileChange = (e: { target: { value: string } }) => {
    this.setState({ mobile: e.target.value });
  };

  onWechatNameChange = (e: { target: { value: string } }) => {
    this.setState({ name: e.target.value });
  };

  render() {
    const { userId } = this.props;
    const { user, userList } = this.state;

    return (
      <>
        <Button style={{ marginLeft: 8 }} size="small" type="primary" onClick={this.onClickTransferButton}>
          转移课程权限
        </Button>
        <Mutation
          mutation={mergeAccountMutation}
          variables={{
            originUserId: userId,
            userId: user && user.id,
          }}
        >
          {(mergeAccount, { loading }) => {
            return (
              <Modal
                width="30%"
                title="课程权限转移"
                visible={this.state.isTransferOwnerOfCoursePopupConfirmVisible}
                onOk={async () => {
                  if (loading) {
                    return;
                  }
                  try {
                    await mergeAccount();
                    message.success('操作成功');
                    this.setState({ isTransferOwnerOfCoursePopupConfirmVisible: false });
                  } catch (error) {
                    const [err] = error.graphQLErrors;
                    message.error(err.message);
                  }
                }}
                onCancel={this.cancelTransferOwnerOperation}
              >
                <Row gutter={24}>
                  <Col span={20}>
                    <div>
                      <Input
                        placeholder="请输入用户手机号"
                        onChange={this.onMobileChange}
                        style={{ width: '60%', marginRight: 10 }}
                      />
                      <Input
                        placeholder="请输入微信昵称"
                        onChange={this.onWechatNameChange}
                        style={{ width: '60%', marginRight: 10 }}
                      />
                      <Button onClick={this.onClickSearchUser} type="primary">
                        搜索用户
                      </Button>
                    </div>
                  </Col>
                </Row>
                {userList && (
                  <Table
                    rowKey="id"
                    rowSelection={{
                      type: 'radio',
                      onChange: (selectedRowKeys, selectedRows) => {
                        const user = selectedRows[0];

                        this.setState({ user });
                      },
                    }}
                    dataSource={userList}
                  >
                    <Table.Column key="id" dataIndex="id" title="id" />
                    <Table.Column key="mobile" dataIndex="mobile" title="手机号" />
                    <Table.Column key="name" dataIndex="name" title="昵称" />
                  </Table>
                )}
              </Modal>
            );
          }}
        </Mutation>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/user/TransferOwnerOfCourse.tsx